module.exports = __webpack_public_path__ + "static/img/dianxing.72d2a2cf.png";